export const MAX_BODY_LENGTH = 125;

export const EDIT_MEMBER_NOTIFICATION_TEMPLATE_FORM_NAME = 'EditMemberNotificationTemplate';
export const SEND_MEMBER_NOTIFICATION_FORM_NAME = 'SendMemberNotifications';
